var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'邀请海报',path:'/shop/system/poster-v2'},
    {title:'基础配置',path:'/shop/system/info'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }